import { render, staticRenderFns } from "./CustomScroll.vue?vue&type=template&id=fc604f84&scoped=true&"
import script from "./CustomScroll.vue?vue&type=script&lang=js&"
export * from "./CustomScroll.vue?vue&type=script&lang=js&"
import style0 from "./CustomScroll.vue?vue&type=style&index=0&id=fc604f84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc604f84",
  null
  
)

export default component.exports